"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _Space_props = require("./Space_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Space =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Space, _PureComponent);

  function Space() {
    _classCallCheck(this, Space);

    return _possibleConstructorReturn(this, _getPrototypeOf(Space).apply(this, arguments));
  }

  _createClass(Space, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var spaceSize = {
        small: 8,
        middle: 16,
        large: 24
      };
      var _this$props = this.props,
          align = _this$props.align,
          children = _this$props.children,
          _this$props$direction = _this$props.direction,
          direction = _this$props$direction === void 0 ? 'horizontal' : _this$props$direction,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 'small' : _this$props$size,
          _this$props$baseClass = _this$props.baseClassName,
          baseClassName = _this$props$baseClass === void 0 ? 'spaui-space' : _this$props$baseClass,
          itemClassName = _this$props.itemClassName,
          _this$props$tagType = _this$props.tagType,
          TagType = _this$props$tagType === void 0 ? 'div' : _this$props$tagType,
          _this$props$itemTagTy = _this$props.itemTagType,
          ItemTagType = _this$props$itemTagTy === void 0 ? 'div' : _this$props$itemTagTy,
          _this$props$display = _this$props.display,
          display = _this$props$display === void 0 ? 'inline-flex' : _this$props$display,
          gap = _this$props.gap,
          _this$props$justify = _this$props.justify,
          justify = _this$props$justify === void 0 ? 'normal' : _this$props$justify,
          style = _this$props.style,
          split = _this$props.split;
      var marginRule = 'marginRight';
      var alignItems = align === undefined && direction === 'horizontal' ? 'center' : align;
      var childNodes = (0, _spauiUtils.isArray)(children) ? children : [children];
      var len = childNodes.length;

      if (len === 0) {
        return null;
      }

      var sizeVal = spaceSize[size];

      if (!sizeVal) {
        sizeVal = "".concat(size, "px");
      }

      ;
      return _react["default"].createElement(TagType, _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(baseClassName, "".concat(baseClassName, "-").concat(direction), _defineProperty({}, "".concat(baseClassName, "-align-").concat(alignItems), alignItems), "".concat(baseClassName, "-justify-").concat(justify))
      }, Space), {
        style: _objectSpread({
          display: display,
          gap: gap ? "".concat(gap, "px") : undefined
        }, style)
      }), childNodes.map(function (child, i) {
        var hasSplit = i < len - 1;
        var item = gap === undefined ? _react["default"].createElement(ItemTagType, {
          className: (0, _classnames["default"])("".concat(baseClassName, "-item"), itemClassName),
          key: "".concat(itemClassName, "-").concat(i),
          style: hasSplit ? _defineProperty({}, direction === 'vertical' ? 'marginBottom' : marginRule, typeof size === 'number' ? size : sizeVal) : {}
        }, child) : child;

        if (_react["default"] && _react["default"].Fragment) {
          return _react["default"].createElement(_react["default"].Fragment, {
            key: "".concat(baseClassName, "-").concat(i)
          }, item, hasSplit && split);
        }

        return item;
      }));
    }
  }]);

  return Space;
}(_react.PureComponent); // 组件标记


_defineProperty(Space, "propTypes", _Space_props.propTypes);

_defineProperty(Space, "defaultProps", _Space_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Space, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Space;
exports["default"] = _default;